// /teamdocs — '팀_문서' 앱 전용 화면 틀.
// TIM_BOX 의 레일·메뉴 없이 문서 관리(통합 문서 작성)만 보여 준다. 같은 서버·같은 계정이라
// TIM_BOX 안의 '통합 문서 작성' 과 같은 목록(아이디별)을 본다.
import { Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useAuth } from "../../shared/stores/auth";
import { authApi } from "../../shared/api/auth";
import { Toasts } from "../../shell/Toasts";
import { I } from "../../shared/Icon";

export default function TeamDocsShell() {
  const nav = useNavigate();
  const { user, setUser, refreshToken, logout } = useAuth();

  useEffect(() => {
    if (!user) authApi.me().then(setUser).catch(() => {});
    document.title = "팀_문서";
    return () => { document.title = "TIM_BOX"; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const signOut = async () => {
    try { if (refreshToken) await authApi.logout(refreshToken); } catch { /* 이미 끊긴 세션 */ }
    logout();
    nav("/login", { state: { from: "/teamdocs" } });
  };

  return (
    // .timple-root 는 overflow:hidden 이다(TIM_BOX 틀은 안쪽 t-main 이 스크롤을 맡는다).
    // 이 틀에도 스크롤을 맡을 칸이 있어야 휴대폰에서 손가락으로 끌어 내릴 수 있다.
    <div className="timple-root" style={{ display: "flex", flexDirection: "column", height: "100dvh", background: "var(--bg)" }}>
      <header data-testid="teamdocs-bar" style={{
        display: "flex", alignItems: "center", gap: 10, padding: "8px 14px", background: "var(--surface)",
        borderBottom: "1px solid var(--border)", position: "sticky", top: 0, zIndex: 20,
      }}>
        <button onClick={() => nav("/teamdocs")} style={{ display: "flex", alignItems: "center", gap: 8, border: 0, background: "transparent", padding: 0, color: "var(--text)" }}>
          <span style={{ width: 30, height: 30, borderRadius: 8, background: "#6E6FCF", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center" }}><I.Docs size={18}/></span>
          <span style={{ fontWeight: 800, fontSize: 16, letterSpacing: "-0.02em" }}>팀_문서</span>
        </button>
        <div style={{ flex: 1 }}/>
        {user && <span style={{ fontSize: 13, color: "var(--text-2)" }}>{user.name || user.username}</span>}
        <button className="t-btn t-btn-sm t-btn-ghost" onClick={signOut} title="로그아웃"><I.Logout size={15}/></button>
      </header>
      <main data-testid="teamdocs-main" style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflowY: "auto", WebkitOverflowScrolling: "touch", overscrollBehavior: "contain" }}>
        <Outlet/>
      </main>
      <Toasts/>
    </div>
  );
}
